import { render, staticRenderFns } from "./PointCloudLoaderButton.vue?vue&type=template&id=09cd83fe&scoped=true"
import script from "./PointCloudLoaderButton.vue?vue&type=script&lang=js"
export * from "./PointCloudLoaderButton.vue?vue&type=script&lang=js"
import style0 from "./PointCloudLoaderButton.vue?vue&type=style&index=0&id=09cd83fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cd83fe",
  null
  
)

export default component.exports